<template>
    <div class="ma-4">
        <v-snackbar v-model="message" top> {{ text }}
            <v-btn color="pink" text @click="message = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        right
                        absolute
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Upcoming Events Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md3 class="pa-1">
                                <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filters.startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="requiredField"
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filters.startDate"
                                        no-title
                                        scrollable
                                        :rules="requiredField"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendarMenu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>

                            </v-flex>

                            <v-flex xs12 md3 class="pa-1">
                                <v-menu
                                    ref="calendarMenu2"
                                    v-model="calendarMenu2"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filters.endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable

                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filters.endDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'

                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu2 = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendarMenu2.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2">
                                <v-select
                                    label="Program"
                                    :items="programs"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="filters.programFilter"
                                    clearable
                                    @change="getEvents"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2">
                                <v-select
                                    label="Event"
                                    :items="eventTypes"
                                    v-model="filters.eventFilter"
                                    clearable
                                    @change="getEvents"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2">
                                <v-select
                                    label="Client Status"
                                    :items="clientStatuses"
                                    v-model="clientStatus"
                                    clearable
                                    @change="getEvents"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2">
                                <v-select
                                    label="Client"
                                    :items="filteredClients"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="filters.clientFilter"
                                    clearable
                                    @change="getEvents"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md3 class="pa-1 mb-2">
                                <v-select
                                    label="Staff"
                                    :items="staffs"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="filters.staffFilter"
                                    clearable
                                    @change="getEvents"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                                <v-btn small @click="getEvents()">Search</v-btn>
                            </v-flex>

                        </v-layout>
                    </v-card>
                </v-flex>

                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="events"
                        sort-by="Name"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Upcoming Events Reports"
                        :items-per-page="itemsPerPage"
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                    >
                        <template v-slot:item.select="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewUpcomingEvent(item)"
                            >
                                View
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>
        <v-dialog v-model="dialog" max-width="100%">
            <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm  }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="clientName"
                                        label="Client Name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="eventName"
                                        label="Event"
                                    ></v-text-field>
                                </v-col>
                                <template v-if="eventName === drsVisit">
                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            v-model="newProviderType"
                                            label="Providers"
                                            :items="providers"
                                            item-text="Name"
                                            item-value="_id"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            v-model="newVisitType"
                                            label="Visit Type"
                                            :items="visitType"
                                            item-value="Name"
                                            item-text="Name"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>
                                </template>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="staffAssigned"
                                        label="Staff Assigned"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="programName"
                                        label="Program"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea
                                        label="Notes"
                                        v-model="notes"
                                        outlined
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Appointment Date and Time"
                                        v-model="eventStartDate"
                                        prepend-icon="mdi-calendar"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        v-model="transportation"
                                        label="Is Transportation Required?"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="transportation === 'Yes'" cols="12" sm="12" md="4">
                                    <v-text-field
                                        label="Transportation From"
                                        v-model="transportationFrom"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="transportation === 'Yes'" cols="12" sm="12" md="4">
                                    <v-text-field
                                        label="Transportation To"
                                        v-model="transportationTo"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        readonly
                                        v-model="createdDate"
                                        label="Date Created"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Created By"
                                        v-model="createdBy"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                    <v-text-field
                                        v-model="signature"
                                        label="Completed By"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="print">
            <report-header>
                <h2>Upcoming Events Report</h2>
            </report-header>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="events"
                        sort-by="Name"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Upcoming Events Reports"
                        :items-per-page="itemsPerPage"
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    // import moment from 'moment'
    import { STATUS_ARRAY } from '../../enums/UserStatusEnum';
    import DateTimeUtil from "../../../utils/date-time.util";
    import ReportHeader from '@/components/Report/ReportHeader.vue';

    const CalendarService = require('../../service/calendar.service');
    // import Foot from '../components/Footer'

    const url = require("../../client_config/config").url;

    export default {
        components: {
            ReportHeader,
        },
        data: () => ({
            headers: [
                {
                    text: 'Appointment Date',
                    align: 'start',
                    sortable: true,
                    value: 'StartDate',
                },
                {text: "Client", value: "Client.Name"},
                {text: "Event Type", value: "Event"},
                {text: "Staff Assigned Type", value: "Staff.Name"},
                {text: "Program", value: "Program.Name"},
                {text: "Transportation", value: "Transportation"},
                {text: "", value: "select"},

                // { text: "Actions", value: "actions", sortable: false },
            ],
            state: '',
            text: '',
            program: '',
            titleForm: '',
            clientName: '',
            createdBy: '',
            createdDate: '',
            eventName: '',
            transportationFrom: '',
            notes: '',
            programName: '',
            signature: '',
            staffAssigned: '',
            eventStartDate: '',
            transportationTo: '',
            transportation: '',
            selectedCalendarEventStartDate: '',
            selectedCalendarEventEndDate: '',
            clients: [],
            Clients: [],
            programs: [],
            events: [],
            staffs: [],
            selectedClientPrograms: [],
            dialog: false,
            message: false,
            isLoading: false,
            calendarMenu: false,
            calendarMenu1: false,
            calendarMenu2: false,
            calendarMenu3: false,
            drsVisit: false,
            // selectedStart: new Date().toISOString().slice(0,10),
            // selectedEnd: new Date(new Date().setTime(new Date().getTime() + 8 * 60 * 60 * 1000)),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            eventTypes: [
                "Activity",
                "Appointment",
                "Birthday",
                "Bus",
                "Dr. Visit",
                "Family Visit",
                "Meeting",
                "Menu",
                "Other",
                "Reminder",
                "Transportation",
                "Vocational Rehabilitation",
                "Team Meeting",
                "Program Meeting"
            ],
            states: ["Utah", "Nevada"],
            userState: localStorage.getItem('userState'),
            userRole: localStorage.getItem('userRole'),
            requiredField: [v => !!v || 'This is required',],
            page: 1,
            pageCount: 1,
            itemCount: 0,
            itemsPerPage: 100,
            options: {},
            clientStatus: "",
            clientStatuses: STATUS_ARRAY,
            filteredClients: [],
            filters: {
                startDate: '',
                endDate: '',
                programFilter: '',
                clientStatus: '',
                clientFilter: '',
                staffFilter: '',
                eventFilter: '',
            }
        }),
        computed: {},

        watch: {
            clientStatus: function(val) {
                if (val == '' || val == null) this.filteredClients = this.clients;
                else this.filteredClients = this.clients.filter((client) => client.Status == val);

                this.filters.clientStatus = val;
            },
            options: {
                handler() {
                    this.getEvents();
                },
                deep: true
            },

            filters: {
                handler() {
                    this.setFilters();
                },
                deep: true
            }
        },

        created() {
            this.getPrograms();
            this.getClients();
            this.getStaffs();
            this.getFilters();
            this.getEvents();
        },

        methods: {
            async getClients () {
                let endpoint = `${url}/clients`;

                await axios.get(endpoint)
                .then((res) => {
                    this.clients = res.data.clients;
                    this.filteredClients = this.clients;
                });
            },

            async getPrograms () {
                await axios.get(`${url}/units/state/${this.userState}`)
                .then((res) => {
                    this.programs = res.data.units;
                })
            },

            getStaffs() {
                axios.get(`${url}/users/state/${this.userState}`).then((res) => {
                    this.staffs = res.data.users;
                    this.getEvents();
                });
            },


            getEvents() {
                // let startDate = moment(this.startDate).startOf('day').toISOString();
                // let endDate = moment(this.endDate).endOf('day').toISOString();
                // startDate = startDate?? this.selectedStart;
                // endDate = endDate?? moment(this.selectedEnd).add(1, 'month').endOf('day').toISOString();


                this.programDialog = false;
                this.clientDialog = false;
                this.staffDialog = false;
                this.eventDialog = false;
                this.isLoading = true;

                let {page, itemsPerPage, sortBy, sortDesc} = this.options;
                page = page || 1;
                itemsPerPage = itemsPerPage || 100;

                const params = {
                    programIds: this.filters.programFilter,
                    clientIds: this.filters.clientFilter,
                    staffIds: this.filters.staffFilter,
                    eventTypes: this.filters.eventFilter,
                    startDate: this.filters.startDate,
                    endDate: this.filters.endDate,
                    clientStatus: this.filters.clientStatus,
                    page: page,
                    limit: itemsPerPage,
                    sortField: sortBy[0],
                    sortDirection: sortDesc[0] ? 'desc' : 'asc',
                    state: this.userState
                };

                CalendarService.get(params)
                    .then((response) => {
                        this.isLoading = false;

                        const {docs, totalPages, totalDocs} = response.data;

                        this.pageCount = totalPages;
                        this.itemCount = totalDocs;

                        this.events = docs.map(event => {
                            event.StartDate = DateTimeUtil.formattedDate(event.StartDate);
                            return event;
                        });
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.message = true;
                        this.text = error.response.data.message;
                        this.color = "red";
                        this.events = [];
                    });
            },

            viewUpcomingEvent(item) {
                this.titleForm = "Viewing " + item.Event;
                this.dialog = true;
                this.newEvent = false;
                this.clientName = item.Client.Name;
                this.createdBy = item.CreatedBy;
                this.createdDate = item.CreatedDate;
                this.endDate = item.EndDate;
                this.eventName = item.Event;
                this.transportationFrom = item.From;
                this.notes = item.Notes;
                this.programName = item.Program.Name || '';
                this.signature = item.Signature;
                this.staffAssigned = item.Staff.Name || '';
                this.eventStartDate = new Date(item.StartDate);
                this.transportationTo = item.To;
                this.transportation = item.Transportation;
                this.eventID = item._id;
            },

            close() {
                this.clear();
                this.isLoading = false;
                this.dialog = false;
            },

            visit() {
                this.drsVisit = this.eventName === "Dr. Visit";
            },


            printTable() {
                window.print()

            },

            clear() {
                this.newTask = "";
                this.newStaffAssigned = "";
                this.newNotes = "";
                this.newTransportation = "";
                this.newDueDate = null;
                this.newFrom = "";
                this.newTo = "";
                this.newTime = "";
                this.newCompletedBy = "";
                this.newProviderType = "";
                this.newVisitType = "";
                this.newProgram = "";
            },

            getFilters() {
                let filters = localStorage.getItem('upcomingEventsReportFilter');
                if (filters) {
                    this.filters = JSON.parse(filters);
                    this.clientStatus = this.filters.clientStatus;
                }
            },

            setFilters() {
                localStorage.setItem('upcomingEventsReportFilter', JSON.stringify(this.filters));
            }
        }
    }
</script>
<style>
    #print {
        display: none
    }

    @media only screen and (min-width: 768px) {
        .mobile {
            display: none;
        }
    }

    @media only screen and (max-width: 600px) {
        .desktop {
            display: none;
        }

    }


    @media only screen and (min-width: 768px) {
        .mobile {
            display: none;
        }
    }

    @media only screen and (max-width: 600px) {
        .desktop {
            display: none;
        }

    }

    @media print {
        #print {
            display: block;
            border: none;
            width: 1200px;
            padding-right: 300px;
            margin-left: -200px;

        }


        nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
            display: none;
            border: none;

        }

        @page {
            margin: 0;
        }

        body {
            margin: 1.6cm;
        }


    }
</style>
